// ============================================================================
// Quarterly Health Report downloads (on-demand PDF).
//
// Both endpoints stream a application/pdf body and are JWT-gated:
//   - org:      GET /api/organizations/<id>/quarterly-report/?year=&quarter=
//               (org admin: own org only · platform admin: any)
//   - national: GET /api/organizations/national/quarterly-report/?year=&quarter=
//               (platform admin only)
// ============================================================================
import { api } from './client.js'

export async function downloadOrgQuarterlyReport(orgId, year, quarter) {
  const res = await api.get(`/api/organizations/${orgId}/quarterly-report/`, {
    params: { year, quarter },
    responseType: 'blob',
  })
  return res.data
}

export async function downloadNationalQuarterlyReport(year, quarter) {
  const res = await api.get('/api/organizations/national/quarterly-report/', {
    params: { year, quarter },
    responseType: 'blob',
  })
  return res.data
}
